// From: https://philipwalton.com/articles/the-google-analytics-setup-i-use-on-every-site-i-build/#error-tracking

export const trackError = (error, fieldsObj = {}) => {
  window.ga('send', 'event', Object.assign({
    eventCategory: 'Script',
    eventAction: 'error',
    eventLabel: (error && error.stack) || (error && error.message) || '(not set)',
    nonInteraction: true,
  }, fieldsObj));
};

const trackErrors = () => {
  const loadErrorEvents = (window.__e && window.__e.q) || [];
  const fieldsObj = {eventAction: 'uncaught error'};

  // Replay any stored load error events.
  for (let event of loadErrorEvents) {
    trackError(event.error, fieldsObj);
  }

  // Add a new listener to track event immediately.
  window.addEventListener('error', (event) => {
    trackError(event.error, fieldsObj);
  });
};

export const gaInit = () => {
  // Initialize the command queue in case analytics.js hasn't loaded yet.
  const ga = window.ga = window.ga || ((...args) => (ga.q = ga.q || []).push(args));
  ga.l = +new Date();

  ga('create', 'UA-262378-11', 'auto');
  ga('set', 'transport', 'beacon');
  ga('send', 'pageview');

  trackErrors();
};




// WEBPACK FOOTER //
// ./src/analytics/index.js